import React from "react";
import { useParams } from "react-router-dom";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import "./Allproduct2.css";

const VeeamIframePage = () => {
  const { type } = useParams();

  const iframeData = {
    "veeam-vvar": {
      title: "Veeam VVAR",
      url: "https://wcs-backupm365-proscope.veeampartnermktg.com/Home",
    },
    "veeam-vcsp": {
      title: "Veeam VCSP",
      url: "https://wcs-veeamdataplatform-proscope.swcontentsyndication.com/Homepage-EN",
    },
  };

  const selectedIframe = iframeData[type];

  if (!selectedIframe) {
    return (
      <>
        <Header />
        <div className="veeam-page-container">
          <h2>Page not found</h2>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <div className="veeam-page-container">
 
        <div className="sw_frame_div">
          <iframe
            title={selectedIframe.title}
            className="sw_frame"
            allow-page-override="true"
            add-utm-params="true"
            src={selectedIframe.url}
          ></iframe>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default VeeamIframePage;